import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";

export function MarketingFinalCta() {
  return (
    <section className="py-24">
      <div className="container mx-auto px-4">
        <div className="relative rounded-3xl overflow-hidden gradient-emerald-radial text-ivory p-12 md:p-20 text-center border border-accent/20">
          <div className="absolute inset-0 bg-grid-emerald opacity-30" />
          <div className="relative">
            <h2 className="font-display text-4xl md:text-6xl text-ivory leading-tight text-balance">
              Bring your press operation <span className="text-gradient-gold">into orbit.</span>
            </h2>
            <p className="text-justify text-ivory/75 mt-5 max-w-xl mx-auto">
              Onboard in 48 hours. White-glove migration. One backbone for everything press.
            </p>
            <div className="mt-8 flex flex-wrap gap-3 justify-center">
              <Link to="/auth?mode=signup">
                <Button size="lg" className="bg-accent text-accent-foreground hover:bg-accent/90 h-12 px-8 gap-2">
                  Request institution access <ArrowRight className="w-4 h-4" />
                </Button>
              </Link>
              <Link to="/portal/login">
                <Button size="lg" variant="outline" className="border-accent/40 text-ivory hover:bg-accent/10 h-12 px-8 bg-transparent">
                  I'm a journalist
                </Button>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
